module.exports = __webpack_public_path__ + "static/media/urbanIcon3.7e983872.svg";